import type { User } from '@lmc/ts-common'
import { Text } from '@lmc/ui-kit/src/general'
import { Popover } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import type { MonitoringUser } from 'screens/Rostering/types'
import styled from 'styled-components'
import TeamMemberCard from './TeamMemberCard'

type TeamMembersPopoverProps = {
  children: ReactNode
  users?: MonitoringUser[]
}

const TeamMembersPopover = ({ children, users }: TeamMembersPopoverProps) => {
  const { t } = useTranslation()

  if (!users) return null

  return (
    <Popover
      placement="bottomRight"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <Container>
          <Text weight="medium" level={2}>
            {t('TEAM_MEMBERS')}
          </Text>
          {users.map((user) => (
            <TeamMemberCard key={user.id} user={user as unknown as User} />
          ))}
        </Container>
      }
    >
      {children}
    </Popover>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 4px;
`

export default TeamMembersPopover
